import React from 'react'
import ProtectedRoute from '../../internal/ProtectedRoute'
import { Authorities } from '../../models/authorities'
import StoreSettings from './StoreSettings'
import PaymentSettings from './PaymentSettings'
import History from './History'
import ApplicationLinks from './ApplicationLinksSettings'

const SettingsRoutes = () => (
  <div>
    <ProtectedRoute
      key="/settings/store"
      exact
      path="/settings/store"
      authority={Authorities.SETTINGS}
      page={<StoreSettings />}
    />
    <ProtectedRoute
      key="/settings/payment"
      exact
      path="/settings/payment"
      authority={Authorities.SETTINGS}
      page={<PaymentSettings />}
    />
    <ProtectedRoute
      key="/settings/history"
      exact
      path="/settings/history"
      authority={[Authorities.SETTINGS, Authorities.USER_ADMINISTRATION]}
      page={<History />}
    />
    <ProtectedRoute
      key="/settings/apply-links"
      exact
      path="/settings/apply-links"
      authority={Authorities.SETTINGS}
      page={<ApplicationLinks />}
    />
  </div>
)

export default SettingsRoutes
